import { Application } from "@evento/application/utils";
import pages from "@evento/nove-otazky/pages";
import { Layout, HomepageLayout } from "@evento/nove-otazky/layouts";
import "@evento/nove-otazky/styles";

const app = new Application()
    .setPages({
        default: pages,
    })
    .setLayouts({
        default: Layout,
        homepage: HomepageLayout,
    })
    .setLayoutResolver(async (name, layouts, resolve) => {
        if (name === "Homepage") {
            return await resolve(layouts.homepage);
        }

        return await resolve(layouts.default);
    })
    .setColor("#e75113")
    .setDebug(import.meta.env.VITE_DEBUG);

app.run();
